export enum GoalType {
    Development = 1,
    Professional = 2,
    Personal = 3,
    Business = 4
}
